import { render, staticRenderFns } from "./ContactosNuevoFeria.vue?vue&type=template&id=0d51cc0e"
import script from "./ContactosNuevoFeria.vue?vue&type=script&lang=js"
export * from "./ContactosNuevoFeria.vue?vue&type=script&lang=js"
import style0 from "./ContactosNuevoFeria.vue?vue&type=style&index=0&id=0d51cc0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports